import { useState } from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { Button } from 'components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { useModelStore } from '../../../state/store/chat/use-model-store';
import { useNavigate } from 'react-router-dom';
import { useGetLlmModel } from '../../../hooks/use-llm-model';

export const ModelSelector = () => {
  const [open, setOpen] = useState(false);
  const { selectedModel, models, openNewChatWithModel } = useModelStore();
  const navigate = useNavigate();
  useGetLlmModel();

  if (models.length === 0) return null;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={`w-full rounded-xl justify-between transition-colors duration-200 focus-visible:ring-0 focus-visible:ring-offset-0 focus:outline-none`}
        >
          <span className="text-xl font-normal">{selectedModel?.name}</span>
          <ChevronDown className="h-4 w-4 opacity-60" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="start"
        className="w-80 p-2 bg-white border-gray-200 shadow-lg rounded-xl"
      >
        {models.map((model) => (
          <DropdownMenuItem
            key={model.id}
            className="focus:bg-transparent focus:text-foreground p-0 cursor-pointer dark:hover:text-gray-900"
            onSelect={(e) => {
              e.preventDefault();
              setOpen(false);
              if (selectedModel?.id !== model.id) {
                openNewChatWithModel(model);
                navigate('/chat');
              }
            }}
          >
            <div className="flex items-center justify-between w-full p-2 rounded hover:bg-muted active:bg-gray-200 transition-all duration-200">
              <div className="flex items-center gap-2">
                <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-100">
                  {model.icon}
                </div>
                <div>
                  <div className="text-sm font-medium text-neutral-800">{model.name}</div>
                  <p className="w-56 text-xs text-gray-500">{model.description}</p>
                </div>
              </div>

              {selectedModel?.id === model.id && (
                <div className="flex items-center justify-center w-4 h-4 bg-primary rounded-full">
                  <Check className="w-3 h-3 text-white" />
                </div>
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
